import type {ReactNode} from 'react'
import styled from 'styled-components'

import {Button, Inline, Stack, __alphaTokens as tokens} from '@pleo-io/telescope'
import {ChevronRight} from '@pleo-io/telescope-icons'

interface ItemProps {
    isSelected?: boolean
    disabled?: boolean
    onClick?: () => void
    children: ReactNode
}
const Item = ({children, disabled, onClick, isSelected}: ItemProps) => (
    <StyledItem>
        <StyledButton
            aria-selected={isSelected}
            variant="link-secondary"
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </StyledButton>
        <StyledIcon>
            <ChevronRight size={16} />
        </StyledIcon>
    </StyledItem>
)

const StyledItem = styled(Inline).attrs({as: 'li', alignItems: 'center', space: 10})``

const StyledIcon = styled(Stack).attrs({justifyItems: 'center'})`
    ${StyledItem}:last-child & {
        display: none;
    }
`

const StyledButton = styled(Button)`
    padding: ${tokens.spacing8} 0;
    border-bottom: ${tokens.sizeBorderDefault} solid ${tokens.colorBackgroundStatic};
    white-space: nowrap;

    &:hover {
        border-bottom: ${tokens.sizeBorderDefault} solid
            ${({disabled}) =>
                disabled ? tokens.colorBackgroundStatic : tokens.colorBorderInteractiveHover};
    }

    &[aria-selected='true'] {
        border-bottom: ${tokens.sizeBorderDefault} solid ${tokens.colorBorderInteractiveSelected};
        color: ${tokens.colorContentInteractive};
        font-weight: ${tokens.fontWeightSemibold};
    }
`

export const Steps = ({children}: {children: ReactNode}) => (
    <nav data-generic-ui="steps">
        <Inline as="ol" space={10} stretchChildren>
            {children}
        </Inline>
    </nav>
)
Steps.Item = Item
